/**
 * PostHog analytics singleton.
 *
 * Initialised once at app boot. Import `posthog` from here — never from
 * posthog-js directly — so we can safely no-op in dev or when the key is
 * absent.
 *
 * Env var: VITE_POSTHOG_KEY  (add to .env and to Replit Secrets)
 * Host:    VITE_POSTHOG_HOST (optional, defaults to PostHog Cloud US)
 */
import posthog from "posthog-js";

const key = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const host = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? "https://us.i.posthog.com";

// TODO: remove after confirming PostHog is working
console.log("[PostHog] key present?", !!key, "| first 8 chars:", key?.slice(0, 8));

if (key) {
  posthog.init(key, {
    api_host: host,

    // --- Session recording ---
    // Mask all images (delivery photos, signatures, etc.) and input text
    // in recordings to avoid capturing sensitive recipient data.
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: "img",
    },

    // Capture pageviews manually via the PostHogPageview component below so
    // Wouter route changes are tracked correctly (SPA navigation).
    capture_pageview: false,

    // Keep a person profile so we can look up agents by name in PostHog.
    person_profiles: "identified_only",
  });
} else {
  // In dev (no key set) PostHog is a no-op. The real `posthog` object from
  // posthog-js silently ignores calls when uninitialised, so this branch is
  // just for the console hint.
  if (import.meta.env.DEV) {
    console.debug("[PostHog] VITE_POSTHOG_KEY not set — analytics disabled in dev");
  }
}

export { posthog };
